<div class="step-box">
    <div class="row">
        <div class="col-sm-12 d-flex">
            <div class="col-sm-6">
                <span jhiTranslate="head-to-head-query.select.traits.label"></span>
            </div>
            <div class="col-sm-6 d-flex">
                <div class="form-check col-sm-2">
                    <input
                            type="radio"
                            id="all"
                            name="traitBasis"
                            [value]="VARIABLE_TYPE_OPTION.ALL"
                            [(ngModel)]="variableType"
                            class="form-check-input"
                            (change)="onVariableTypeChange()"
                    />
                    <label for="all" class="form-check-label" jhiTranslate="head-to-head-query.select.traits.all.option">All</label>
                </div>
                <div class="form-check col-sm-2">
                    <input
                            type="radio"
                            id="traits"
                            name="traitBasis"
                            [value]="VARIABLE_TYPE_OPTION.TRAITS"
                            [(ngModel)]="variableType"
                            class="form-check-input"
                            (change)="onVariableTypeChange()"
                    />
                    <label for="traits" class="form-check-label" jhiTranslate="head-to-head-query.select.traits.traits.option">Traits</label>
                </div>
                <div class="form-check col-sm-2">
                    <input
                            type="radio"
                            id="analysis"
                            name="traitBasis"
                            [value]="VARIABLE_TYPE_OPTION.ANALYSIS"
                            [(ngModel)]="variableType"
                            class="form-check-input"
                            (change)="onVariableTypeChange()"
                    />
                    <label for="analysis" class="form-check-label" jhiTranslate="head-to-head-query.select.traits.analysis.option">Analysis</label>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="row mt-2 mb-2">
            <div class="col-8">
                <div class="mb-3 d-flex align-items-center">
                    <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                    <div class="p-2">
                        <span jhiTranslate="common.selected">Selected:</span>
                        <span class="fw-bold pl-2">
                            {{ isSelectAll ? totalItems : selectedItems.size }}
                        </span>
                    </div>
                    <div class="form-check form-check-inline pl-5">
                        <input (click)="onSelectAll(isSelectAll)" [checked]="isSelectAll" class="form-check-input" id="check-select-all" name="check-select-all" [ngbTooltip]="'global.select.all' | translate" type="checkbox">
                        <label class="form-check-label pl-2" for="check-select-all" jhiTranslate="global.select.all">
                            Select all pages
                        </label>
                    </div>
                    <div class="ms-2">
                        <button class="btn btn-sm btn-outline-info" (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
                    </div>
                    <span *ngIf="isLoading" class="throbber ms-2"></span>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-striped table-bordered table-curved">
                <thead>
                <tr jhiSort [(predicate)]="predicate" [(ascending)]="isAscending" [callback]="this.transition.bind(this)">
                    <th *ngIf="!isSelectAll"><input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()" [title]="'global.select.current.page' | translate" data-test="selectCurrentPageCheckbox"></th>
                    <th>
                            <span jhiSortBy="name">
                                <span jhiTranslate="head-to-head-query.column.header.variable.name"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th>
                            <span jhiSortBy="property">
                                <span jhiTranslate="head-to-head-query.column.header.property"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th>
                            <span jhiSortBy="definition">
                                <span jhiTranslate="head-to-head-query.column.header.description"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th>
                            <span jhiSortBy="numberOfEnvironments">
                                <span jhiTranslate="head-to-head-query.column.header.no.of.environments"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th>
                            <span jhiTranslate="head-to-head-query.column.header.direction"></span>
                    </th>
                </tr>
                </thead>
                <tbody *ngIf="traits.length else nodata">
                <tr *ngFor="let trait of traits; trackBy: trackId; index as index">
                    <td *ngIf="!isSelectAll">
                        <input type="checkbox" class="form-check-input" [checked]="isSelected(trait)" (click)="toggleSelect($event, index, trait, true); $event.stopPropagation()">
                    </td>
                    <td >{{trait.variableName}}</td>
                    <td >{{trait.property}}</td>
                    <td >{{trait.description}}</td>
                    <td >{{trait.numberOfEnvironments}}</td>
                    <td [ngStyle]="{ 'min-width': '120px' }">
                        <select (ngModelChange)="selectDirection(trait)"
                                [(ngModel)]="trait.direction"
                                [disabled]="!isSelected(trait)"
                                class="form-select">
                            <option [value]="1">
                                {{'head-to-head-query.direction.increasing' | translate}}
                            </option>
                            <option [value]="0">
                                {{'head-to-head-query.direction.decreasing' | translate}}
                            </option>
                        </select>
                    </td>
                </tr>
                </tbody>
            </table>
            <ng-template #nodata>
                <tbody>
                <tr>
                    <td [attr.colspan]="6" jhiTranslate="no.data"></td>
                </tr>
                </tbody>
            </ng-template>
        </div>
        <div *ngIf="traits && traits.length">
            <div class="row">
                <div class="col">
                    <div class="pagination-container">
                        <div class="pagination-box pagination-box-left">
                            <div>
                                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                            </div>
                        </div>
                        <div class="pagination-box">
                            <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                            [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                        </div>
                        <div class="pagination-box pagination-box-right">
                            <div class="d-flex align-items-center">
                                <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                                <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 text-center">
            <button class="btn btn-secondary ms-2" (click)="prevStep()" jhiTranslate="back">Back</button>
            <button class="btn btn-primary ms-2" [disabled]="disableNextStep()" (click)="nextStep()" jhiTranslate="next">Next</button>
        </div>
    </div>
</div>
